<template>
  <div class="card-wrap" v-loading="loading">
    <template v-if="tableData.length>0">
      <div
        class="card-item"
        v-for="(item, index) in tableData"
        :key="index"
        @click="hotClick(item.questiontitle)"
      >
        <span class="sort">{{ index + 1 }}</span>
        <p class="overh quest" :title="item.questiontitle">{{ item.questiontitle }}</p>
      </div>
    </template>
    <template v-else>
      <div class="card-empty">暂无数据</div>
    </template>
  </div>
</template>

<script>
import utils from "@mixins/utils";

export default {
  mixins: [utils],
  data() {
    return {
      loading: false,
      tableData: []
    };
  },
  mounted() {
    this.getData()
  },
  methods: {
    hotClick(title) {
      this.$store.dispatch("analysis/updateHits", {visitlocation: "首页-热门搜索"});
      window.location.assign("/everydayQuestion");
      sessionStorage.setItem("title", title);
    },
    getData() {
      this.loading = true
      this.$ajax({
        url: `${this.$store.state.api.webUrl}/question/hotsearchlist.json`,
        data: {
          limit: 8,
        },
        callback: data => {
          this.tableData = data;
        },
        complete: () => {
          this.loading = false;
        }
      });
    }
  },
};
</script>

<style scoped lang="scss">
.card-wrap {
  padding: 4px 30px 34px 30px;
  border-radius: 8px;
  background: #FFFFFF;
  height: 100%;

  .card-item {
    display: flex;
    align-items: center;
    margin-top: 20px;
    cursor: pointer;

    .sort {
      width: 6px;
      font-weight: bold;
      font-size: 16px;
      color: #9498A6;
      margin-right: 9px;
    }

    &:nth-of-type(1) {
      .sort {
        color: #FF374E;
      }
    }

    &:nth-of-type(2) {
      .sort {
        color: #FF7100;
      }
    }

    &:nth-of-type(3) {
      .sort {
        color: #FAAB13;
      }
    }

    .quest {
      font-weight: 400;
      font-size: 14px;
      color: #333333;
    }
  }
}

.card-empty {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-weight: 400;
  font-size: 14px;
  color: #aaa;
  text-align: center;
  padding-top: 20px;
}
</style>

